// Import dependencies
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import _ from "lodash";
import React, { Component } from "react";
import IdleTimer from "react-idle-timer";
import injectSheet from "react-jss";
import { Redirect } from "react-router-dom";
import { Subject } from "rxjs";
import { di } from "../../bottle";
import { Container, Header, InfoCard, Text } from "../../components";
import { BikeChanges } from "../../managers/Garage";
// Import component
import { Customize } from "./components/Customize";
import { ChangeConfirmation } from "./components/Customize/components";
import { FullSummary } from "./components/FullSummary";
import { InactivityWarning } from "./components/Modals/InactivityWarning";
import { LanguageChangeWarning } from "./components/Modals/LanguageChangeWarning";
import { ResetWarning } from "./components/Modals/ResetWarning";
import { Sumnmary } from "./components/Summary";
import { Transition } from "react-transition-group";
import TweenMax from "gsap/TweenMaxBase";

// Component
class Customization extends Component {
  constructor(props) {
    // call base constructor
    super(props);

    // initialize instance variables
    this.idleTimer = null;
    this.partCategoryTap$ = new Subject();
    this.titleContainer = null;

    // initialize state
    this.state = {
      loading: true,
      showInfoCard: false,
      showFullSummary: false,
      resetBike: false,
      resetWarningVisible: false,
      inactivityWarningVisible: false,
      languageChangeWarningVisible: false,
      infoMaxWith: "100%",
      confirmationRequest: null,
      emailError: false,
    };

    // bind methods
    this._onBikeChanged = this._onBikeChanged.bind(this);
  }

  componentDidMount() {
    this._garageSubscription = di.garage.bikeChanges$.subscribe((bikeChanges) =>
      this._onBikeChanges(bikeChanges)
    );
  }

  componentWillUnmount() {
    // unregister the garage subscription
    if (this._garageSubscription) {
      this._garageSubscription.unsubscribe();
      this._garageSubscription = null;
    }
  }

  _onBikeChanges = (bikeChanges) => {
    // handle bike reset
    if (bikeChanges.type === BikeChanges.ResetType) {
      di.modelManager.hideAllParts();
    }

    // or send changes for an update (if required)
    if (bikeChanges.changes.length > 0) {
      const changes = bikeChanges.changes;

      console.log("[onBikeCahanges]", changes);
      di.modelManager.showBike(di.garage.bike);
    }
  };

  onPressInfoIcon = () => {
    this.setState({
      showInfo: true,
    });
  };

  onCloseInfoCard = () => {
    this.setState({
      showInfo: false,
    });
  };

  onShowFullSummary = () => {
    if (this.animator) {
      this.animator.reverse()
    } else {
      this.setState({
        showFullSummary: true,
      });
    }

    let bikeType;
    if (di.garage.bikeModel.id === "AR") {
      bikeType = "can-am ryker rotax Rally Edition";
    } else if (di.garage.bikeModel.id === "602") {
      bikeType = "can-am ryker rotax 600 ace";
    } else {
      bikeType = "can-am ryker rotax 900 ace";
    }

    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "e_fullSummary",
      model: bikeType,
      country: di.profileManager.region,
      language: di.localization.locale,
    });
  };

  onCloseFullSummary = () => {
    this.setState({
      showFullSummary: false,
    });
  };

  resetBike = () => {
    this.setState({
      resetWarningVisible: true,
    });
  };

  cancelReset = () => {
    this.setState({
      resetWarningVisible: false,
      inactivityWarningVisible: false,
    });
  };

  confirmReset = () => {
    this.setState({
      resetBike: true,
    });

    let bikeType;
    if (di.garage.bikeModel.id === "AR") {
      bikeType = "can-am ryker rotax Rally Edition";
    } else if (di.garage.bikeModel.id === "SPORT") {
      bikeType = "can-am ryker rotax Sport Edition";
    } else if (di.garage.bikeModel.id === "602") {
      bikeType = "can-am ryker rotax 600 ace";
    } else {
      bikeType = "can-am ryker rotax 900 ace";
    }

    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "e_restart",
      model: bikeType,
    });
  };

  onLanguageChange = () => {
    this.setState({
      languageChangeWarningVisible: true,
    });
  };

  cancelLanguageChange = () => {
    di.profileManager.toggleLanguage();

    this.setState({
      languageChangeWarningVisible: false,
    });
  };

  onIdle = () => {
    this.setState({
      inactivityWarningVisible: true,
    });
  };

  onRef = (ref) => {
    if (!this.titleContainer) {
      this.titleContainer = ref;
      this.setState({
        infoMaxWith: this.titleContainer.offsetWidth + 55,
      });
    }
  };

  async _onBikeChanged(bikeUpdate) {
    // TODO: refactor the change object itself to be articulate
    const { changes, validationFixes } = bikeUpdate;
    let pendingChanges = validationFixes
      .filter((fix) => fix.pendingChanges)
      .map((fix) => fix.pendingChanges)
      .reduce((result, value) => result.concat(value), []);
    pendingChanges = _.uniqBy(
      pendingChanges,
      (c) => `${c.operation}|${c.part.sku}`
    );

    // TODO: move this into some sensible place
    const isSwap =
      changes.length === 2 &&
      _.uniqBy(changes, (c) => `${c.part.categoryId}|${c.part.subcategoryId}`)
        .length === 1;
    const showConfirmation = pendingChanges.length > 0 && !isSwap;

    // show confirmation dialog if required (returns a promise)
    if (showConfirmation) {
      return new Promise((resolve) => {
        // create request
        const request = ChangeConfirmation.createRequest(
          pendingChanges,
          (confirmed) => {
            // resolve
            resolve(confirmed);

            // clear request
            this.setState({ confirmationRequest: null });
          }
        );
        // update state with request
        this.setState({ confirmationRequest: request });
      });
    }
    // or update immediately
    else {
      return true;
    }
  }

  render() {
    const {
      resetBike,
      resetWarningVisible,
      inactivityWarningVisible,
      languageChangeWarningVisible,
      confirmationRequest,
    } = this.state;

    const isGlobal = di.profileManager.region === "GBL";

    // if reset requested navigate back to selection page
    if (resetBike) {
      return (
        <Redirect
          to={{ pathname: "/selection", search: this.props.location.search }}
        />
      );
    }

    // resolve inputs
    const { garage, localization } = di;

    // check if garage has a bike. if not redirect to home page
    if (!garage.bike || garage.bike.parts.length == 0) {
      console.log("[CustomizationPage] redirecting to home page");
      return (
        <Redirect
          to={{ pathname: "/selection", search: this.props.location.search }}
        />
      );
    }

    const bikeType = garage.bikeModel;
    const bike = garage.bike;

    // get model / engine
    let title = "";
    let subtitle = "";
    let description = "";

    if (bikeType.id === "AR") {
      title = localization.get("selection.rykerRally.title");
      subtitle = localization.get("selection.rykerRally.subtitle");
      description = localization.get("selection.rykerRally.description");
    } else if (bikeType.id === "SPORT") {
      title = localization.get("selection.rykerSport.title");
      subtitle = localization.get("selection.rykerSport.subtitle");
      description = localization.get("selection.rykerSport.description");
    } else if (bike.engine.sku === "602") {
      title = localization.get("selection.ryker600.title");
      subtitle = localization.get("selection.ryker600.subtitle");
      description = localization.get("selection.ryker600.description");
    } else {
      title = localization.get("selection.ryker900.title");
      subtitle = localization.get("selection.ryker900.subtitle");
      description = localization.get("selection.ryker900.description");
    }

    let price = "";
    let currency = "";
    let localizedPrice = "";
    let priceString = "";

    if (!isGlobal) {
      price = di.catalogManager.priceForPart(
        `${bike.model.sku}.${bike.engine.sku}`
      );
      localizedPrice = di.profileManager.localizePrice(price, true);
      currency = di.profileManager.currency;
      if (
        di.profileManager.region == "DE" ||
        di.profileManager.region == "FR"
      ) {
        priceString = di.localization.get(
          "selection.startingAt",
          localizedPrice,
          ""
        );
      } else {
        priceString = di.localization.get(
          "selection.startingAt",
          localizedPrice,
          currency
        );
      }
    }
    // conditionally render confirmation
    const confirmation = (
      <ChangeConfirmation
        visible={!!confirmationRequest}
        request={confirmationRequest}
      />
    );
    return (
      <IdleTimer
        ref={(ref) => {
          this.idleTimer = ref;
        }}
        element={document}
        onIdle={this.onIdle}
        timeout={1000 * 60 * 3}
      >
        <Container flex style={styles.container} touchless>
          <Header onLanguageChange={this.onLanguageChange} />

          <ResetWarning
            visible={resetWarningVisible}
            onClose={this.cancelReset}
            onConfirm={this.confirmReset}
          />

          <InactivityWarning
            visible={inactivityWarningVisible}
            onClose={this.cancelReset}
            onConfirm={this.confirmReset}
          />

          <LanguageChangeWarning
            visible={languageChangeWarningVisible}
            onClose={this.cancelLanguageChange}
            onConfirm={this.confirmReset}
          />

          <Container
            style={{ ...styles.bikeInfo, maxWidth: this.state.infoMaxWith }}
            touchless
          >
            <InfoCard
              style={{ height: "inherit", width: 515 }}
              show={this.state.showInfo}
              title={title}
              priceString={priceString}
              description={description}
              onClose={this.onCloseInfoCard}
            />

            <span ref={this.onRef} style={styles.title}>
              {title.toUpperCase()}
            </span>
            <Container direction="row" style={styles.infoContainer}>
              <Text style={styles.description}>{subtitle}</Text>
              <ButtonBase
                style={styles.infoIconContainer}
                onClick={this.onPressInfoIcon}
              >
                <img
                  src={require("../../assets/images/btn-info.png")}
                  style={styles.infoIcon}
                />
              </ButtonBase>
            </Container>

            <Transition
              timeout={1}
              appear
              mountOnEnter
              unmountOnExit
              in={!this.state.showFullSummary}
              addEndListener={(node, done) => {
                this.animator = TweenMax.from(node, 0.7, {
                  autoAlpha: 0,
                  y: "-=50",
                  onReverseComplete: () => {
                    this.setState({
                      showFullSummary: true,
                    });
                  },
                  onComplete: done
                }
                )
              }}
              >
              <Sumnmary onPressButton={this.onShowFullSummary} />
            </Transition>

            <FullSummary
              show={this.state.showFullSummary}
              onPressBackButton={this.onCloseFullSummary}
              onBikeChanged={this._onBikeChanged}
            />
          </Container>
          <Customize
            canCustomize={!this.state.showFullSummary}
            onPressReset={this.resetBike}
            partCategoryTap$={this.partCategoryTap$}
            onBikeChanged={this._onBikeChanged}
          />
          {confirmation}
        </Container>
      </IdleTimer>
    );
  }
}

// styles
const styles = {
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    userSelect: "none",
  },
  bikeInfo: {
    position: "relative",
    paddingTop: 25,
    paddingLeft: 50,
  },
  title: {
    color: "#ffffff",
    fontSize: 40,
    fontFamily: "TradeGothicLTBold",
  },
  infoContainer: {
    display: "flex",
    paddingTop: 15,
    paddingBottom: 15,
  },
  description: {
    color: "#ffffff",
  },
  infoIconContainer: {
    padding: 10,
    height: 45,
  },
  infoIcon: {
    height: 25,
    minWidth: 25,
    width: 25,
  },
  contentBlock: {
    padding: "0 0",
  },
  arContainer: {
    zIndex: 1,
  },
};

const CustomizationPage = injectSheet(styles)(Customization);
export { CustomizationPage };



// WEBPACK FOOTER //
// ./src/pages/Customization/index.js